import Permissions from '@app/src/auth/permissions'
import { usePermissions } from '@app/src/auth/permissions/usePermissions'

export const useWriteAccess = (): boolean => {
  const { hasPermission } = usePermissions()
  return !hasPermission(Permissions.VIEW_ONLY_ACCESS)
}

export default useWriteAccess
